import { z } from 'zod'
import { StationTWN } from '@library/enums'

/** 航點 Schema */
export const airportSchema = z.object({
  /** 區域代碼 */
  areaCode: z.string(),
  /** 國家代碼 */
  countryCode: z.string(),
  /** 代碼 */
  code: z.union([z.enum(StationTWN), z.string()]),
  /** 名稱 */
  name: z.string(),
  /** 是否為線上 */
  online: z.boolean(),
  /** 是否有效 */
  enable: z.boolean()
})

/** 航點 */
export interface Airport extends z.infer<typeof airportSchema> {}
